import unescapedText from 'I18n/utils/unescapedText';
const IS_CUSTOMER_AGENT_KEY = 'isCustomerAgent';
export const groupOwnerReferences = (references, referenceToOption) => {
  const customerAgentRefs = [];
  const userRefs = [];
  for (const ref of references) {
    var _ref$additionalProper;
    if (((_ref$additionalProper = ref.additionalProperties) === null || _ref$additionalProper === void 0 ? void 0 : _ref$additionalProper[IS_CUSTOMER_AGENT_KEY]) === 'true') {
      customerAgentRefs.push(ref);
    } else {
      userRefs.push(ref);
    }
  }
  const result = [];
  if (customerAgentRefs.length > 0) {
    result.push({
      text: unescapedText('referenceResolversLite.owners.customerAgentsGroup'),
      selectAll: true,
      options: customerAgentRefs.map(referenceToOption)
    });
  }
  if (userRefs.length > 0) {
    result.push({
      text: unescapedText('referenceResolversLite.owners.usersGroup'),
      selectAll: true,
      options: userRefs.map(referenceToOption)
    });
  }
  return result;
};